import React from 'react';
// @ts-expect-error incompatibility with node16 resolution
import {Listbox} from '@headlessui/react';
import clsx from 'clsx';
import {ChevronDownIcon} from '../icons/ChevronDown';
import RadioIcon from '../icons/Radio';
import SpinnerIcon from '../icons/Spinner';
// import Cookies from 'js-cookie';
import {withCookies} from 'react-cookie';
import type {Cookies as CookiesType} from 'react-cookie';
import {useLocalization} from '@shopify/hydrogen';

//context
import {GlobalContext} from '../../GlobalProvider.client';
import {Global} from '@emotion/react';

function CurrencySelect({cookies}: {cookies: CookiesType}) {
  const {
    country: {isoCode},
  } = useLocalization();
  const currencyList = [
    {
      symbol: '$',
      value: 'HKD',
      label: '($) HKD',
      display: 'HKD',
      emoji: '🇭🇰',
      emoji_code: '1f1ed-1f1f0',
    },
    {
      symbol: '$',
      value: 'TWD',
      label: '($) TWD',
      display: 'TWD',
      emoji: '🇹🇼',
      emoji_code: '1f1f9-1f1fc',
    },
    {
      symbol: '$',
      value: 'USD',
      label: '($) USD',
      display: 'USD',
      emoji: '🇺🇸',
      emoji_code: '1f1fa-1f1f8',
    },
    {
      symbol: '$',
      value: 'AUD',
      label: '($) AUD',
      display: 'AUD',
      emoji: '🇦🇺',
      emoji_code: '1f1e6-1f1fa',
    },
    {
      symbol: '$',
      value: 'NZD',
      label: '($) NZD',
      display: 'NZD',
      emoji: '🇳🇿',
      emoji_code: '1f1f3-1f1ff',
    },
    {
      symbol: '$',
      value: 'IDR',
      label: '(Rp) IDR',
      display: 'IDR',
      emoji: '🇮🇩',
      emoji_code: '1f1ee 1f1e9',
    },
  ];

  const currencySettings = React.useContext(GlobalContext);

  // const defaultCurrency = isoCode === 'TW' ? 'TWD' : 'HKD';
  const defaultCurrency = currencySettings?.baseCurrency ?? 'HKD';

  const savedCurrency = cookies.get('hk-currency');

  const [listboxOpen, setListboxOpen] = React.useState(false);
  const [currency, setCurrency] = React.useState(defaultCurrency);

  React.useEffect(() => {
    setCurrency(savedCurrency ?? defaultCurrency);
  }, []);

  const setCurrentCurrency = React.useCallback<(currency: string) => void>(
    (currency) => {
      setCurrency(currency);
      cookies.set('hk-currency', currency);
    },
    [currency],
  );

  const selectedCurrency = currencySettings?.all_currencies.find(
    (c) => c.currency === currency,
  );

  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    setLoaded(true);
  }, []);

  if (!loaded) {
    return <></>;
  }

  return (
    <div className="z-[1000] h-[2.4rem] text-sm md:h-auto">
      <Listbox onChange={setCurrentCurrency} value={currency}>
        {({open}: {open: boolean}) => {
          setTimeout(() => setListboxOpen(open));
          return (
            <div className="relative inline-flex h-full">
              <Listbox.Button
                className={clsx(
                  'flex items-center rounded-sm bg-hk-orange px-3 py-2 text-sm font-normal duration-150 md:bg-transparent',
                  'hover:bg-opacity-10',
                )}
              >
                <span className="mr-2">
                  {`${selectedCurrency?.currency}`}
                </span>
                <ChevronDownIcon className={clsx(open && 'rotate-180')} />
              </Listbox.Button>

              <Listbox.Options
                className={clsx(
                  'absolute top-full left-1/2 mt-3 min-w-[150px] -translate-x-1/2 overflow-hidden rounded bg-white shadow',
                )}
              >
                <div className="bg-white">
                  {listboxOpen && (
                    <ul className="">
                      {currencySettings &&
                        currencySettings?.all_currencies &&
                        currencySettings.all_currencies?.map(
                          (currentCurrency) => (
                            <Listbox.Option
                              key={currentCurrency.currency}
                              value={currentCurrency.currency}
                            >
                              {({active}: {active: boolean}) => (
                                <div
                                  className={clsx([
                                    'flex cursor-pointer items-center justify-between space-x-8 whitespace-nowrap p-3 text-left text-sm font-normal',
                                    active ? 'bg-darkGray bg-opacity-5' : null,
                                  ])}
                                >
                                  <div className="flex items-center space-x-1">
                                    <img
                                      alt={
                                        currentCurrency?.details?.currency?.name
                                      }
                                      className="inline-block w-4"
                                      src={`${currentCurrency?.details?.image}`}
                                    />
                                    <span className="">
                                      {`${currentCurrency?.currency}`}
                                    </span>
                                  </div>
                                  <div className="text-hk-orange">
                                    <RadioIcon
                                      checked={
                                        currency === currentCurrency?.currency
                                      }
                                      hovered={active}
                                    />
                                  </div>
                                </div>
                              )}
                            </Listbox.Option>
                          ),
                        )}
                      {/* {currencyList.map((currentCurrency) => (
                        <Listbox.Option
                          key={currentCurrency.value}
                          value={currentCurrency.value}
                        >
                          {({active}: {active: boolean}) => (
                            <div
                              className={clsx([
                                'flex cursor-pointer items-center justify-between space-x-8 whitespace-nowrap p-3 text-left text-sm font-normal',
                                active ? 'bg-darkGray bg-opacity-5' : null,
                              ])}
                            >
                              <div className="flex items-center space-x-1">
                                <img
                                  alt={currentCurrency.emoji}
                                  className="inline-block w-4"
                                  src={`https://twemoji.maxcdn.com/v/14.0.2/svg/${currentCurrency.emoji_code}.svg`}
                                />
                                <span className="">
                                  {currentCurrency.display}
                                </span>
                              </div>
                              <div className="text-hk-orange">
                                <RadioIcon
                                  checked={currency === currentCurrency.value}
                                  hovered={active}
                                />
                              </div>
                            </div>
                          )}
                        </Listbox.Option>
                      ))} */}
                    </ul>
                  )}
                </div>
              </Listbox.Options>
            </div>
          );
        }}
      </Listbox>
    </div>
  );
}

export default withCookies(CurrencySelect);
